<template>
  <div id="app">
    <router-view></router-view> <!-- 动态渲染内容 -->
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>
<style scoped>
        /* 可选：如果你想让背景也充满屏幕，可以这样设置 */
        #app {
            margin: 0;
            padding: 0;
            height: 100%; /* 让body的高度为100% */
            overflow: hidden; /* 防止滚动条出现 */
        }
</style>